import { CreatorProfile } from "models";
import { Box, capitalize } from "reusable";

export const ProfileBanner = (props: {
  profile: CreatorProfile | null;
}): JSX.Element => {
  if (!props.profile) {
    return <></>;
  }

  const { lookingForJob, firstName, position, isHiring } = props.profile;

  return (
    <>
      {lookingForJob && position !== "Business Owner" ? (
        <Box className="looking-for-job-banner" textAlign="center">
          {capitalize(firstName || "")} is looking for a job. Are you Hiring?
        </Box>
      ) : (
        <>
          {isHiring && position === "Business Owner" ? (
            <Box
              className="looking-for-job-banner hiring-banner-theme"
              textAlign="center"
            >
              {capitalize(firstName || "")} is hiring. Are you looking for job?
            </Box>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};
